import TopDestinationCard from '../../components/TopDestinationCard/TopDestinationCard.vue';
import HorizontalScroll from "vue-horizontal-scroll";
import "vue-horizontal-scroll/dist/vue-horizontal-scroll.css";
import { GET_LOCATIONS, GET_TOP_DESTINIES } from "../../store/destinies/getter-types";
import Axios from "axios";
import { mapGetters, mapActions } from "vuex";
import { FETCH_PLACES } from "../../store/destinies/action-types";

export default {
  props: {
    title: {
      type: String,
      required: false
    },
    subtitle: {
      type: String,
      required: false
    },
    btnLabel: {
      type: String,
      required: false
    }
  },
  components: {
    TopDestinationCard
  },
  computed: {
    ...mapGetters({
      topDestinations: GET_TOP_DESTINIES,
    }),
  },
  methods: {
    ...mapActions({
      fetchPlaces : FETCH_PLACES
    }),
    navigateToDestinies() {
      this.$router.push({ name: "destinies" }).catch(() => {});
    },
  },
  created(){
    this.fetchPlaces();
  }
};
